var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['check-list-item', { 'check-list-item--selected': _vm.isSelected }]},[_c('label',[_c('input',_vm._b({attrs:{"type":"checkbox"},on:{"change":_vm.handleChange}},'input',_vm.$attrs,false)),_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }